import urlResolver from 'edrolo/utils/URLResolver';
import { ProfileMenuItem } from './type';
import { enums } from 'edrolo-ui';
import Waffle from 'edrolo/utils/Waffle';
import { Profile } from 'edrolo/types/Profile';

interface IProfileItem {
  mySchool: ProfileMenuItem;
  myClasses: ProfileMenuItem;
  classEditor: ProfileMenuItem;
  myDetails: ProfileMenuItem;
  admin: ProfileMenuItem;
  edroloCentral: ProfileMenuItem;
  help: ProfileMenuItem;
  trainingFeedback: ProfileMenuItem;
  signOut: ProfileMenuItem;
}

export const profileItems: IProfileItem = {
  mySchool: {
    id: 1,
    title: 'My school',
    href: urlResolver.reverse('school'),
    iconName: enums.Icons.SCHOOL,
  },
  myClasses: {
    id: 2,
    title: 'My classes',
    href: urlResolver.reverse('classes'),
    iconName: enums.Icons.CLASS,
  },
  classEditor: {
    id: 3,
    title: 'Class editor',
    href: urlResolver.reverse('class-editor'),
    iconName: enums.Icons.CLASS,
  },
  myDetails: {
    id: 4,
    title: 'My details',
    href: urlResolver.reverse('profile'),
    iconName: enums.Icons.GEAR,
  },
  admin: {
    id: 5,
    title: 'Admin',
    href: urlResolver.reverse('django-admin'),
    iconName: enums.Icons.ADMIN,
  },
  edroloCentral: {
    id: 6,
    title: 'Edrolo Central',
    href: 'https://edrolodocs.atlassian.net/wiki/spaces/KBOPS/overview?homepageId=1816035541',
    iconName: enums.Icons.SHIELD,
  },
  help: {
    id: 7,
    title: 'Help',
    href: 'https://help.edrolo.com.au/',
    iconName: enums.Icons.HELP,
  },
  trainingFeedback: {
    id: 8,
    title: 'Training feedback',
    href: 'https://crpvd04.na1.hs-sales-engage.com/Ctc/U+23284/cRpvd04/Jl22-6qcW7lCdLW6lZ3kLW9hNZcq26G5pvW8PV2sY6Zm9QbW7gMRKh5j8t79N2hwXfjkPvBSN17_dPrNWxKXW14djMJ8B95c2W3lSFQY4QMZxJW6Cf6Hm7ldW4hVSq6pG8LZD4JW1fVPrj464F0gW61gQNl2q1Zv2W1nRjd_22DwP6V4XrW83BqLjkN7Hb541NLTQMW2s_K1Q75-mZbW1MTzNX4tVy_7W5sGtJT1mB0Y7W49zQS167nBsGW4J-5qm467lzsW2Nkm6n3jpXlFTBhW_2LJ3jcW1BpJtB5-3M62W63SVK14c1zcYN6mnNbGDZJL3f5tcm5g04',
    iconName: enums.Icons.FEEDBACK,
  },
  signOut: {
    id: 9,
    title: 'Sign out',
    href: urlResolver.reverse('logout'),
    iconName: enums.Icons.SIGN_OUT,
  },
};

export const getProfileMenuItems = (profile: Profile) => {
  const menuItems: ProfileMenuItem[] = [
    profileItems.myDetails,
    profileItems.help,
    profileItems.signOut,
  ];

  if (profile.is_poc || profile.is_staff) {
    menuItems.push(profileItems.mySchool);
  }
  // ** Experimental code **
  if (Waffle.flag_is_active('experiment:insights.school')) {
    if (
      profile.is_staff ||
      profile.is_poc ||
      // quick check for HODs
      Object.values(profile.school_classes)?.some(
        (sc) => sc.position === 'SUPERVISOR'
      )
    ) {
      menuItems.push({
        id: 1.5,
        title: 'My school insights',
        href: urlResolver.reverse('school-dashboard', {
          schoolSlug: profile.school_slug,
        }),
        iconName: enums.Icons.FLASK,
      });
    }
  }

  if (profile.can_upload_flatfiles) {
    menuItems.push({
      id: 3.5, // After "My details"
      title: 'Upload class lists',
      href: urlResolver.reverse('class-list-uploader', {}),
      iconName: enums.Icons.ADMIN,
    });
  }

  if (profile.is_teacher) {
    menuItems.push(profileItems.myClasses, profileItems.trainingFeedback);
  }

  if (Waffle.flag_is_active('class-editor:external-beta')) {
    if (profile.is_teacher || profile.is_poc || profile.is_staff) {
      menuItems.push(profileItems.classEditor);
    }
  }

  if (profile.is_staff) {
    menuItems.push(profileItems.admin, profileItems.edroloCentral);
  }

  return menuItems;
};
